import { render, staticRenderFns } from "./Comp24t2.vue?vue&type=template&id=54ead62d&scoped=true&"
import script from "./Comp24t2.vue?vue&type=script&lang=js&"
export * from "./Comp24t2.vue?vue&type=script&lang=js&"
import style0 from "./Comp24t2.vue?vue&type=style&index=0&id=54ead62d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54ead62d",
  null
  
)

export default component.exports